<template>
  <span
    class="material-symbols-outlined"
    style="font-variation-settings: 'FILL' 1"
  >
    add_card
  </span>
</template>

<style scoped>
.material-symbols-outlined {
  font-family: 'Material Symbols Outlined';
}
</style>
